module.exports = __webpack_public_path__ + "static/media/koryu_00009.772c856b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/koryu_00009.png
// module id = 228
// module chunks = 0